import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Redirect } from 'react-router';

import { connect } from 'react-redux'
import AdminMenu from '../../components/Admin/MenuDetalhes/AdminMenu';

import DuvidasEditarSection from "./DuvidasEditarSection";


class DuvidasEditar extends Component {
  constructor(props){
    super(props);

    this.state= {
      isAdmin: false
    };
  }

  componentWillMount() {
    const isAdmin = localStorage.getItem('_IS_ADM');
    
    if(!isAdmin) {
      window.location.href = '/';
      return;
    }
    
    this.setState({ isAdmin });
  }

  render() {
    return (
      this.state.isAdmin && <>
        <AdminMenu />         
        <DuvidasEditarSection idResposta = { this.props.match.params.idResposta } />        
      </>
    )
  }
}

const mapStateToProps = store =>({view_by_tab:store.home.aba})
export default connect(mapStateToProps)(withRouter(DuvidasEditar))
 